import * as React from 'react';
import { ChartDataContext } from "../context/Chart";
import { Spinner } from "./Spinner";

export type SegmentAveragesProps = {
    filter_id: string;
}

export const SegmentAverages = (props: SegmentAveragesProps): JSX.Element => {
    const [chartdata,] = React.useContext(ChartDataContext);

    if (chartdata.result_set === undefined) {
        return <></>
    }

    const segmentResults = chartdata.result_set.filter((result) => result.filter_id === props.filter_id);

    if (chartdata.fetching) {
        return <Spinner title={'Bezig met het ophalen van de gegevens'} />;
    }

    return <div className={'c-rstats__segment__averages'}>
        {segmentResults.map((result,r_idx) => {

            return <div key={result.title} className={'c-pstats__segment__average'}>
                <h5>{result.title}</h5>
                <dl>
                    <dt>Aantal respondenten</dt>
                    <dd>{result.count_complete}</dd>
                </dl>
                <div className={'c-pstats__segment__average__label'}>Score</div>
                    <ul className={'c-pstats__segment__percentages'}>{result.result.map((persona, idx) => {
                    return <li key={`avg_${r_idx}_${idx}`}>{persona.title}:<br />{persona.percent.toFixed(2)}%</li>
                })}</ul>
            </div>

        })}
    </div>;
}
